var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-sheet-field',{attrs:{"align":"center","is-sticky":_vm.isSticky,"field":_vm.field,"filter":_vm.filter}},[_c('span',[_vm._v(_vm._s(_vm.value)),(_vm.total)?_c('span',{staticClass:"plays-total"},[_vm._v(" ("+_vm._s(_vm.total)+")")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }